import React from 'react';
import { Button } from 'antd';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { CloseOutlined, LeftOutlined, MenuOutlined } from '@ant-design/icons';
import logo from '/public/images/logoonly.png';
import ThemeToggle from '../../../../components/ThemeToggle';
import styles from '../../styles.module.css';
import { URLParamsContext } from '../../../../index';

const TariffBreakdownNavBar = ({
  context,
  t,
  tariffData,
  isMobile,
  isMobileMenuVisible,
  toggleMobileMenu,
  selectedCategory,
}) => {
  // Get navbar visibility from URL params context
  const { showNavbar } = React.useContext(URLParamsContext);

  return (
    <div className={styles.tariffBreakdownTopNav}>
      {showNavbar ? (
        <div className={styles.tariffBreakdownLogoContainer}>
          <img src={logo} alt="Logo" className={styles.logoImg} />
          <div className={styles.logoText}>
            <span className={styles.lecoText}>
              {t('label_tariff_breakdown')}
            </span>
            <span className={styles.subTitle}>
              {t('label_updated')} {tariffData?.meta?.effectiveDate}
            </span>
          </div>
        </div>
      ) : isMobileMenuVisible ? (
        <h1 className={styles.categoryText}>Categories</h1>
      ) : (
        <h1 className={styles.categoryText}>{selectedCategory}</h1>
      )}
      <div className={styles.navActions}>
        {!isMobile && showNavbar && (
          <Button
            type="text"
            icon={<LeftOutlined />}
            title={t('label_back_to_bill_calculator')}
            className={styles.backButton}
          >
            <Link to={{ pathname: `/${context.appName}` }}>
              {t('label_back_to_bill_calculator')}
            </Link>
          </Button>
        )}
        {showNavbar && <ThemeToggle t={t} />}
        {isMobile && (
          <Button
            type="text"
            icon={isMobileMenuVisible ? <CloseOutlined /> : <MenuOutlined />}
            className={styles.mobileMenu}
            onClick={toggleMobileMenu}
          />
        )}
      </div>
    </div>
  );
};

export default withTranslation()(TariffBreakdownNavBar);
